import { API_URL } from "constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (eventId, page = 1, days = 5) => `${API_URL}/api/v2/spots/${eventId}?days=${days}&page=${page}`;

const getAvailableSpots = async (eventId, page = 1, days = 5) => await apiRequest(getUrl(eventId, page, days), "get");

export default getAvailableSpots;